import { Layout } from "antd";
import styled from "styled-components";

const { Content } = Layout;

export const ContainerLayout = styled(Layout)`
    min-height: 100vh;
`;

export const ContentLayout = styled(Layout)`
    padding: 32px;
`;

export const ContentStyled = styled(Content)`
    display: flex;
    flex-direction: column;
    margin: 0;
`;
